<template>
    <div>
      <join-member-dialog :value="joinDialog.isShowDialog"
                          :outerContent="joinDialog.dialogTitle"
                          :mainContent="joinDialog.dialogMsg"
                          class="wallet-dialog"
                          :isCancel="joinDialog.cancelable"
                          @result="onJoinMemberDialogClose"/>
        <navigation-bar Logo Bell/>
        <div class="qr-code main">
            <div class="top text-center" v-show="isLogin">
                <h4 v-if="activeButton === 'bank'">請結帳人員掃描條碼</h4>
                <h4 v-if="activeButton === 'scan'||activeButton ===''">請掃描會員條碼</h4>
            </div>
            <div class="qr-block">
                <div class="avatar">
                    <div class="image_empty" v-if="avatar===''"/>
                    <el-image v-else :src="avatar" fit="cover" lazy/>
                </div>
                <div class="code">
                    <p class="name">{{nickname}}</p>
<!--                    <vue-qrcode id='qrcode' v-if="agree" v-model="qrcodeSrc"/>-->
                    <!-- vue-qrcode 2.2.0 以上要用下面的寫法 -->
                    <vue-qrcode id="qrcode" :color="{ dark: '#000000ff', light: '#ffffffff' }" type="image/png" v-if="agree" :value="qrcodeSrc"/>
                    <div class="small">
                        <el-button icon="el-icon-refresh-right"
                                   size="mini"
                                   class="mr-1"
                                   @click="callGetApiTokenApi()"
                                   circle/>
                        更新 <b class="red">{{timeStr}}</b>
                    </div>
                </div>
                <el-row type="flex" justify="center" class="buttons" v-show="isLogin">
                    <el-col :span="8" v-if="false">
                        <!--todo 未綁定錢包-->
                        <el-button @click="isWalletDialog=true"
                                   :class="{active: activeButton === 'bank'}"
                                   circle>
                            <img v-if="activeButton === 'bank'" src="@/assets/images/card_white.svg">
                            <img v-else src="@/assets/images/card.svg" alt="支付">
                        </el-button>

                        <!--todo 已經有綁定錢包-->
                        <el-button @click="activeButton = 'bank'"
                                   :class="{active: activeButton === 'bank'}"
                                   circle v-if="false">
                            <img v-if="activeButton === 'bank'" src="@/assets/images/card_white.svg">
                            <img v-else src="@/assets/images/card.svg" alt="支付">
                        </el-button>

                    </el-col>
                    <el-col :span="8" v-if="false">
                        <el-button @click="activeButton = 'scan'" :class="{active: activeButton === 'scan'}" circle>
                            <img v-if="activeButton === 'scan'" src="@/assets/images/scan_white.svg">
                            <img v-else src="@/assets/images/scan.svg" alt="會員掃碼">
                        </el-button>
                    </el-col>
                    <el-col :span="8">
                        <el-button @click="onClickCamera" :class="{active: activeButton === 'camera'}" circle>
                            <img src="@/assets/images/camera.svg" alt="相機">
                        </el-button>
                    </el-col>
                </el-row>
            </div>
            <div class="otherPay"
                 :class="{ openBox: isActive }"
                 v-if="false">
                <!--v-if="activeButton === 'scan' && isLogin"-->
                <div class="payType">
                    <div class="green info" @click="OpenOtherPay('open')" v-if="!isActive">使用<b>其他支付</b></div>
                    <div class="green info"  v-else>請先<b>確認</b>店家是否接受其他電子支付<br>此動作將會另開啟APP</div>
                    <div class="content">
                        <div class="row">
                            <div class="col-3 col-md-2" @click="isCreditCard=true">
                                <img src="../../assets/images/pay/other_pay_credit_card.svg" alt="信用卡">
                            </div>
                            <div class="col-3 col-md-2">
                                <img src="../../assets/images/pay/other_pay_linepay.svg" alt="linePay">
                            </div>
                            <div class="col-3 col-md-2">
                                <img src="../../assets/images/pay/other_pay_easywallet.svg" alt="悠遊付">
                            </div>
                            <div class="col-3 col-md-2">
                                <img src="../../assets/images/pay/other_pay_pi.svg" alt="玉山pi錢包">
                            </div>
                            <div class="col-3 col-md-2">
                                <img src="../../assets/images/pay/other_pay_wechatpay.svg" alt="微信支付">
                            </div>
                            <div class="col-3 col-md-2">
                                <img src="../../assets/images/pay/other_pay_alipay.svg" alt="支付寶">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="closeBtn" @click="OpenOtherPay('close')"></div>
            </div>
            <!--todo 高踞信用卡彈框-->
            <el-dialog
                    :visible.sync="isCreditCard"
                    class="credit-card-dialog"
                    :close-on-click-modal="false"
                    :show-close="false"
                    :modal="false"
                    top="30%"
                    width="80%">
                <div class="container">
                    這邊放高踞iframe
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="isCreditCard = false" type="info">取消</el-button>
                        <el-button type="primary">送出</el-button>
                    </div>
                </div>
            </el-dialog>

            <div class="payBank"
                 v-if="activeButton === 'bank'&&isShowDialog=== false"
                 @click="$router.push({name:'CreditCardPick'})">
                <el-row type="flex" justify="space-between">
                    <el-col :span="4">
                        <img src="@/assets/images/card-visa.svg">
                    </el-col>
                    <el-col :span="13">
                        <ul>
                            <li class="bank">台新國際商業銀行</li>
                            <li>1234-5617-****-**36</li>
                        </ul>
                    </el-col>
                    <el-col :span="7">
                        <span>切換信用卡</span>
                        <i class="el-icon-arrow-right"></i>
                    </el-col>
                </el-row>
            </div>

            <comm-dialog v-bind="cDialog" class="dialog-dark" @result="onCommDialogClose"/>

            <!--todo 前往設定錢包-->
            <comm-dialog :value="isWalletDialog"
                         :outerContent="'尚未設定錢包'"
                         :mainContent="'是否前往設定？'"

                         class="wallet-dialog"
                         @result="onWalletDialogClose"/>
            <!--todo 支付密碼登入-->
            <password-dialog v-if="activeButton === 'bank'"
                             :value="isShowDialog"
                             @result="onDialogResult"/>


        </div>
    </div>
</template>

<script>
import VueQrcode from "vue-qrcode";
// import Contact from "cordova-plugin-contacts";
import CommDialog from '@/components/CommDialog.vue';
import PasswordDialog from "./components/PasswordDialog";
import JoinMemberDialog from "@/components/JoinMemberDialog";
import * as mutationTypes from "@/store/mutationTypes";
// import OpenCameraPlugin from 'cordova-plugin-custom-util';

import * as constDefine from '@/store/constDefine';
import shortUrl from "@/util/shortUrl";
import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";

const eventTypeConst = {//-1是不執行任何動作
  openUrlWithCloseBtn: -2,
  addMember: 2,
  qrcodeSendCoupon: 3,
  qrcodeSendLoyaltyCard: 4,
  qrcodeSendRewardPoint: 5,
  qrcodeSendGiftPack: 6,
};

export default {
  name: "Scan",
  props: {
      openScanType: {default: ''},
  },
  components: {
      VueQrcode,
      CommDialog,
      PasswordDialog,
      JoinMemberDialog,
  },
  data() {
    return {
      nickname: '',
      avatar: '',
      qrcodeSrc: '1',
      timer: null,
      time:0,
      timeStr:'',
      agree: true,
      isLogin: false,
      scanResult: '',
      activeButton: 'scan',
      isAndroid: false,             //目前是否爲 android 平臺
      delayRun: null,
      paramData: {},
      isMember: false,
      cDialog: {                    // commDialog 用
          value: false,
          eventType: 0,
          outerContent: '',
          mainContent: '',
          isModal: false,
          isCancel: false,
          isShowClose: false,
      },
      openUrl: '',
        isShowDialog: true,//支付密碼彈框
        isActive: false,//開啟其他支付
        isWalletDialog: false,//設定錢包彈框
        isCreditCard: false,//高踞信用卡彈框
      joinDialog: {
        isShowDialog: false,
        dialogTitle: '',
        dialogMsg: '',
        cancelable: false,
      },
      userData: {},

      gifType: 0, //掃碼領取成功重刷畫面用參數
    }
  },
    created() {
        this.isLogin = this.$auth.isAdminLogin();
        if (this.isLogin) {
            //如果有登入就取得個人資訊
            // this.callGetUserInfoApi();
            this.updateUserInfo();
            this.callGetApiTokenApi();

            //是否爲 android 平臺？
            this.isAndroid = (this.$http.getOS() === 'Android');

            //讀取掃描結果
            let scanResult = localStorage.getItem('cameraResult');
            if (scanResult !== null && scanResult !== '') {
                //讀取完要清除，要再取得結果就要重新掃描
                localStorage.setItem('cameraResult', '');

                //讀取掃描結果
                let result = this.$store.state.scanResult;
                this.$store.commit('clrScanResult');

                this.delayRun = setTimeout(() => {
                    this.onScanResult(result);
                }, 500);
            }
        }
    },
    mounted() {
        //開始計時
        this.resetTimeCountDown();

        if (!this.isLogin) {
            this.showDialog('請先登入', '', true);
        }
        // this.onScanResult('https://survey.oinapp.com/questionnaire/2Utregs8iBQwnol7HFjTe7SsZ5c5EkasKgmjr5HgYE1BLHIvmcK%2FD1sKxrRV8ux7fDxsjDilxjCW4eXflTDGcbmOp11ug9rMjsdBejczeOuSfwPJhVohLR5mOuXn%2FxgxCpQGgX1iN0PIjR02g%2FIaDZ7bfxpJuQky3610OTtZBP6p%2BekSrC%2BKGdKn6xdm1IjpsX%2BpylqtvCZ6hvzlLQ%3D%3D');
    },
    beforeDestroy() {
        //清除延遲執行
        clearTimeout(this.delayRun);
        this.stopTimer();
    },
    methods: {

        /** 顯示訊息 dialog */
        showDialog: function (title, msg, cancelable = false, eventType = 0) {
            this.cDialog.value = true;
            this.cDialog.outerContent = title;
            this.cDialog.mainContent = msg;
            this.cDialog.isCancel = cancelable;
            this.cDialog.eventType = eventType;
        },

        /** CommDialog 關閉事件 */
        onCommDialogClose(result, eventType) {
            this.cDialog.value = false;

            if (eventType === 0) {
                if (result) {
                    this.$router.push({name: 'Login'});
                } else {
                    this.$router.go(-1)
                }
            } else if (eventType === 1 || eventType === eventTypeConst.openUrlWithCloseBtn) {
                //type == 1，開啓 url
                if (result) {
                    let isCordova = !!window.cordova;
                    if (isCordova) {
                        if (this.openUrl.startsWith('https://survey.oinapp', 0) || this.openUrl.startsWith('https://survey-test.oinapp', 0) || eventType === eventTypeConst.openUrlWithCloseBtn) {
                            this.$public.openUrlWithCloseBtn(this.openUrl);
                        } else {
                            //開啓頁面
                            this.$public.openUrl(this.openUrl);
                        }
                    } else {
                        window.open(this.openUrl);
                    }
                }
            } else if (result && eventType === eventTypeConst.addMember) {
                this.showJoinMemberDialog("加入會員", "是否同意成爲品牌會員？", true);
            } else if (result && eventType === eventTypeConst.qrcodeSendCoupon) {
                this.qrcodeSendCoupon();
            } else if (result && eventType === eventTypeConst.qrcodeSendLoyaltyCard) {
                this.qrcodeSendLoyaltyCard();
            } else if (result && eventType === eventTypeConst.qrcodeSendRewardPoint) {
                this.qrcodeSendRewardPoint();
            } else if (result && eventType === eventTypeConst.qrcodeSendGiftPack) {
                this.qrcodeSendGiftPack();
            } else if (result && eventType === -1 && this.gifType === eventTypeConst.qrcodeSendCoupon) {
                this.gifType = 0; //參數歸零。防呆
                this.$emit('result', "getCoupon");
            }
        },

        /** 變更大頭圖 */
        updateUserInfo: function () {
            // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
            const userData = getCryptoUserInfo();
            this.avatar = userData.picture;
            this.nickname = userData.nickName;
            this.userData = userData;
        },

        /** 接收掃描結果 */
        onScanResult: async function (value) {
            this.scanResult = value;

            //判斷是否爲名片
            if (this.scanResult.toLowerCase().startsWith('begin:vcard', 0)) {
                let os = this.$http.getOS();
                if ( os === 'Android' || os === 'iOS') {
                    let customPlugin = window.cordova.plugins.CustomUtilPlugin;
                    customPlugin.insertContacts(this.scanResult);

                }
            }


            //是否爲其他網頁
            let url = this.scanResult;
            if (url.startsWith('http://', 0) || url.startsWith('https://', 0)) {
                let scanURL = new URL(url);

                if (url.startsWith('http://192.168.50.44:8080', 0) || url.startsWith('https://waiting.', 0) || url.startsWith('https://waiting-test.', 0)) {
                    url = this.scanResult + '/' + this.$crypto.decryptText(window.localStorage.getItem('token')).split(';')[0] + '?t=app';

                    let self = this;
                    let loop = null;
                    // let browser = this.$public.isCordova()? window.cordova.InAppBrowser: window;
                    let appInBrowser = window.cordova.InAppBrowser.open(url, '_blank', 'toolbar=no,location=no' + self.$http.browserOpenFeatures());

                    if (this.$public.isCordova()) {
                        appInBrowser.addEventListener('message', function(...args) {
                            if (self.$public.notNull(args) && self.$public.notNull(args[0])) {
                                let msgObj = args[0];
                                if (msgObj.type === 'message') {
                                    if (self.$public.notNull(msgObj.data) &&
                                        self.$public.notNull(msgObj.data.message)){
                                        if (msgObj.data.message === 'close') {
                                            appInBrowser.close();
                                        }
                                    }
                                }
                            }
                        }, false);

                        //監聽 '載入完成' 事件
                        appInBrowser.addEventListener('loadstop', function(event) {
                            loop = setInterval(function() {

                                appInBrowser.executeScript(
                                    {
                                        //此寫法表示，把 location.href傳給 function( values )，注意 values爲陣列
                                        code: "location.href;"
                                    },
                                    function( values ) {
                                        //植入另一段 javascript
                                        if (self.$public.notNull(values) && self.$public.notNull(values[0]) &&
                                            values[0].indexOf('waiting/app/home') >= 0) {

                                            clearInterval( loop );
                                            appInBrowser.executeScript({
                                                code: "\
                                                    const messageObj = { message: 'close'};" +
                                                    "document.getElementById('closeBtn').addEventListener('click',function(e){" +
                                                    "webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(messageObj));" +
                                                    "}, false);"
                                            });
                                        }
                                    }
                                );
                            }, 1000);
                        }, true);
                    }
                    return;
                }

                if (url.startsWith('https://o-test.oinapp.com/') || url.startsWith('https://o.oinapp.com/')) {
                    let data = await this.getOriginalURL(url);
                    url = data.url;
                }
                //是否爲系統的問卷？
                let isOpened = false;   //是否有達成開啓頁面？
                if (url.startsWith('https://survey.oinapp', 0) || url.startsWith('https://survey-test.oinapp', 0)) {
                    const getUrlParam = urlDivideAry => {
                        let urlParam = urlDivideAry[1];
                        let paramDecode = decodeURIComponent(urlParam);
                        let paramDecrypto = this.$crypto.decryptText(paramDecode);
                        return JSON.parse(paramDecrypto);
                    }

                    if (url.includes('questionnaire/')) {
                        let urlDivideAry = url.split('questionnaire/');
                        if (urlDivideAry.length === 2) {
                            let paramData = getUrlParam(urlDivideAry);

                            // console.log('urlParam: '+ urlParam + '\n' +
                            //     'paramDecode: '+ paramDecode + '\n' +
                            //     'paramDecrypto: '+ paramDecrypto + '\n' +
                            //     'paramData: '+ paramData + '\n' );

                            //需不需要登入？
                            if (paramData.isLogin) {
                                let isLogin = this.$auth.isAdminLogin();
                                if (isLogin) {
                                    // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                                    const userData = getCryptoUserInfo();
                                    let name = userData.name;
                                    let tel = userData.phone;
                                    let combo = name + ';' + tel + ';APP';
                                    let crypto_ = this.$crypto.encryptText(combo);
                                    let param = encodeURIComponent(crypto_);

                                    //開啓網頁, type = 1
                                    this.openUrl = url + '/' + param;
                                    console.log('openUrl: '+ url + '/' + param);
                                    this.showDialog('是否打開台灣享樂遊問卷？', '', true, 1);

                                } else {
                                    //沒登入的話就導到登入
                                    await this.$router.push({name: 'Login'});
                                }

                                isOpened = true ;
                            }
                        }
                    } else if (url.includes('form/')) {
                        let urlDivideAry = url.split('form/');
                        if (urlDivideAry.length === 2) {
                            let paramData = getUrlParam(urlDivideAry);
                            paramData.params.isCordova = this.$public.isCordova();
                            let param = encodeURIComponent(this.$crypto.encryptText(JSON.stringify(paramData)));
                            url = urlDivideAry[0] + 'form/' + param;
                            let isLogin = this.$auth.isAdminLogin();
                            if (isLogin) {
                                // const userData = JSON.parse(localStorage.getItem('userInfo') || "");
                                const userData = getCryptoUserInfo();
                                let name = userData.name;
                                let tel = userData.phone;
                                let combo = name + ';' + tel + ';';
                                combo += this.$public.isCordova() ? 'app' : 'web';
                                let crypto_ = this.$crypto.encryptText(combo);
                                let param = encodeURIComponent(crypto_);

                                //開啓網頁, type = 1
                                this.openUrl = url + '/' + param;
                                console.log('openUrl: ' + url + '/' + param);
                                this.showDialog('是否打開台灣享樂遊表單？', '', true, 1);
                            } else {
                                //沒登入的話就導到登入
                                await this.$router.push({name: 'Login'});
                            }
                            isOpened = true;
                        }
                    }


                    if (!isOpened) {
                        //開啓網頁, type = 1
                        this.openUrl = url;
                        isOpened = true ;

                        // console.log('openUrl: '+ this.openUrl);
                        this.showDialog('是否打開台灣享樂遊問卷？', '', true, 1);
                    }
                }

                try {
                    if(!isOpened && scanURL.search !== "") {
                        let params = scanURL.searchParams;
                        let newParams = {};
                        let openContent = ""

                        for (let pair of params.entries()) {
                            if(pair[0] === "dataToken") {
                                let dataObject = this.$crypto.uriComponentToObject(pair[1])
                                if (dataObject.usedType === constDefine.QRCodeUsedType.TableOrder) {
                                    openContent = "是否打開桌邊服務？"

                                    dataObject.userData = this.$public.getUserData()
                                    dataObject.isAppOpen = true

                                    newParams[pair[0]] = this.$crypto.objectToURIComponent(dataObject)
                                }
                            }
                        }

                        if(openContent !== "") {
                            scanURL.search = new URLSearchParams(newParams).toString();
                            url = scanURL.href

                            this.openUrl = url;
                            this.showDialog(openContent, '', true, eventTypeConst.openUrlWithCloseBtn);
                            return false;
                        }
                    }
                } catch (e) {
                    //
                }

                if (!isOpened) {
                    //非系統問卷
                    //開啓網頁, type = 1
                    this.openUrl = url;

                    // console.log('openUrl: '+ this.openUrl);
                    this.showDialog('是否前往外部網頁？', '', true, 1);
                    return false;
                }
            }


            if (this.scanResult !== "") {
              this.paramData = JSON.parse(this.scanResult);
              if(typeof this.paramData.dataToken !== "undefined") {
                let dataJson = this.$crypto.decryptText(this.paramData.dataToken)
                let data = JSON.parse(dataJson)
                this.paramData = {...this.paramData, ...data}
              }

              switch (this.paramData.usedType) {
                case constDefine.QRCodeUsedType.SendCoupon:
                  if(this.paramData.couponListId > 0) {
                    this.checkIsAddStore();
                  } else {
                    this.showDialog("優惠券資料異常", '', false, -1);
                  }
                  break;
                case constDefine.QRCodeUsedType.SendLoyaltyCard:
                  if(this.paramData.loyaltyCardListId > 0) {
                    this.checkIsAddStore();
                  } else {
                    this.showDialog("集點卡資料異常", '', false, -1);
                  }
                 break;
                case constDefine.QRCodeUsedType.SendGiftPack:
                  if(this.paramData.giftPackListId > 0) {
                    this.checkIsAddStore();
                  } else {
                    this.showDialog("禮包資料異常", '', false, -1);
                  }
                  break;
                case constDefine.QRCodeUsedType.QRCodePay:
                    /* 掃描結帳功能 */
                    this.$router.push({name: `QRcodePay`,query:{'totalPrice':this.paramData.totalPrice, 'storeId': this.paramData.storeId, 'orderId': this.paramData.orderId}});
                    break;
                case constDefine.QRCodeUsedType.SendRewardPoint:
                  if(this.paramData.rewardPointListId > 0) {
                    this.checkIsAddStore();
                  } else {
                    this.showDialog("紅利點數資料異常", '', false, -1);
                  }
                 break
                default:
                  break;
              }
            }
        },

        /** 照相機 icon 點擊 */
        onClickCamera() {
            this.activeButton = 'camera';

            //呼叫相機頁
            this.$router.push({name: `ScanCode`, query: {openScanType: this.openScanType}});
        },

        /** 停止計時器 */
        stopTimer: function () {
            clearInterval(this.timer);
        },

        /** 倒數 */
        countdown: function () {
            this.time--;
        },

        /** 重設計時器 */
        resetTimeCountDown: function () {
            this.time = 300;

            //設定計時器
            this.timer = setInterval(() => {
                this.countdown();
                //更新時間字串
                this.timeStr = this.getTimeString();

                if (this.time === 0) {
                    //停止計時器
                    this.stopTimer();
                    //重新取得 token
                    this.callGetApiTokenApi();
                    //重新計時
                    this.resetTimeCountDown();
                }
            }, 1000);
        },

        /** 取得 time(秒數) 轉成的時間字串 */
        getTimeString: function () {
            return Math.floor(this.time / 60).toString().padStart(2, '0') + ':' + Math.floor(this.time % 60).toString().padStart(2, '0');
        },

        /** 取得 token(需先登入) */
        callGetApiTokenApi: function () {
            let self = this;
            this.$http.fetchWithAuth`GetApiToken${{}}
                ${json => {
                    if (json.status) {
                        //把 token給 qrcodeSrc
                        self.qrcodeSrc = json.data;
                    }
                }
            }`;
        },
        //開啟touch id或密碼登入
        onDialogResult() {
            this.isShowDialog = false;
        },
        //開啟設定錢包
        onWalletDialogClose(){
            this.isWalletDialog = false;
            this.$router.push({ name: 'CreditCardPrivacy' });
        },
        //開啟其他支付
        OpenOtherPay(type){
            if(type==='open'){
                this.isActive=true
            }
            if(type==='close'){
                this.isActive=false
            }
        },
        isAddStore(storeId) {
          let self = this
          return new Promise(function(resolve) {
            if(storeId === 0) {
              self.isMember = true
              resolve();
            } else {
              self.$http.fetchWithAuth`IsAddStore${{
                id: storeId
              }} ${json => {
                self.isMember = json.status;
                resolve();
              }}`;
            }
          });
        },
        checkIsAddStore() {
          let self = this
          let paramData = self.paramData;
          self.isAddStore(paramData.storeId).
            then(() => {
              if(self.isMember) {
                self.usedTypeEvent()
              } else {
                self.showDialog('您尚未成為該店家會員，沒辦法使用該功能，是否同意成為會員呢？', '', true, eventTypeConst.addMember);
              }
            });
        },
        showJoinMemberDialog: function (title, msg, cancelable = false) {
          this.joinDialog.cancelable = cancelable;
          this.joinDialog.dialogTitle = title;
          this.joinDialog.dialogMsg = msg;
          this.joinDialog.isShowDialog = true;
        },
        onJoinMemberDialogClose: function(result) {
          let self = this;
          let paramData = self.paramData;
          self.joinDialog.isShowDialog = false;

          if(result) {
            if (paramData.storeId > 0) {
              self.addMember(paramData.storeId)
                  .then( () => {
                    self.usedTypeEvent()
                  })
                  .catch( (error) => {
                    self.showDialog(error, '', false, -1);
                  });
            }
          }
        },
        addMember(storeId) {
          let self = this;
          return new Promise(function(resolve, reject) {
            self.$http.fetchWithAuth`AddStore${{
              id: storeId
            }} ${json => {
              self.isMember = json.status;

              if (json.status) {
                resolve();
              } else {
                reject('無法加入會員:' + json.message);
              }

            }}`;
          });
        },
        qrcodeSendCoupon() {
            let self = this
            let paramData = self.paramData;
            self.$http.fetchWithAuth`QRCodeSendCoupon${{
                id: paramData.couponListId,
                storeId: paramData.storeId,
                sendObject: paramData.sendObject,
                sendObjectId: paramData.sendObjectId,
            }} ${json => {
                if (json.status) {
                    this.gifType = eventTypeConst.qrcodeSendCoupon;
                }

                self.showDialog(json.message, '', false, -1);
            }}`;
        },
        qrcodeSendLoyaltyCard() {
          let self = this
          let paramData = self.paramData;
          self.$http.fetchWithAuth`QRCodeSendLoyaltyCard${{
            id: paramData.loyaltyCardListId,
            storeId: paramData.storeId,
            sendObject: paramData.sendObject,
            sendObjectId: paramData.sendObjectId,
            isCheckStore: paramData.isCheckStore,
          }} ${json => {
            self.showDialog(json.message, '', false, -1);
          }}`;
        },
        qrcodeSendRewardPoint() {
          let self = this
          let paramData = self.paramData;
          self.$http.fetchWithAuthEncrypt`QRCodeSendRewardPoint${{
            id: paramData.rewardPointListId,
            storeId: paramData.storeId,
            sendObject: paramData.sendObject,
            sendObjectId: paramData.sendObjectId,
          }} ${json => {
            self.showDialog(json.message, '', false, -1);
          }}`;
        },
        qrcodeSendGiftPack() {
            let self = this
            let paramData = self.paramData;
            self.$http.fetchWithAuthEncrypt`QRCodeSendGiftPack${{
                id: paramData.giftPackListId,
                sendObject: paramData.sendObject,
                sendObjectId: paramData.sendObjectId,
            }} ${json => {
                self.showDialog(json.message, '', false, -1);
            }}`;
        },
        usedTypeEvent() {
            let self = this
            let paramData = self.paramData;

            switch (paramData.usedType) {
              case constDefine.QRCodeUsedType.SendCoupon:
                self.showDialog('是否確定領取' + paramData.name + "，" + paramData.amount + "張", '', true, eventTypeConst.qrcodeSendCoupon);
                break;
              case constDefine.QRCodeUsedType.SendLoyaltyCard:
                self.showDialog('是否確定領取' + paramData.name + "，" + paramData.amount + "點", '', true, eventTypeConst.qrcodeSendLoyaltyCard);
                break;
              case constDefine.QRCodeUsedType.SendRewardPoint:
                self.showDialog('是否確定領取' + paramData.name + "，" + paramData.amount + "點", '', true, eventTypeConst.qrcodeSendRewardPoint);
                break;
              case constDefine.QRCodeUsedType.SendGiftPack:
                self.showDialog('是否確定領取' + paramData.name + "，" + paramData.amount + "包", '', true, eventTypeConst.qrcodeSendGiftPack);
                break;
              default:
                break;
            }
        },
        /** 取得短網址的原始網址 **/
        async getOriginalURL(url) {
            return shortUrl.getOriginalURL(url);
        },
    }
}
</script>

<style lang="less" scoped src="../../less/scan.less"/>
